import { message } from 'antd';
import _ from 'lodash';
import { useState } from 'react';
import ReactPlacesAutocomplete from 'react-places-autocomplete';
import { OptionType, PlacesSelect, PlacesSelectProps } from './PlacesSelect';

const selectStyles = {
  control: (styles: any) => ({ ...styles, border: 'none', borderRadius: '5px' }),
};

export type PlacesAutocompleteProps = {
  onChange(placeId: string | null): void;
  sessionToken: google.maps.places.AutocompleteSessionToken;
};

export function isMultiValue(
  option: null | OptionType | readonly OptionType[],
): option is OptionType[] {
  if (_.isArray(option)) return true;
  return false;
}

export function isSingleValue(
  option: null | OptionType | readonly OptionType[],
): option is OptionType {
  if (!option) return false;
  if (isMultiValue(option)) return false;
  return true;
}

export function PlacesAutocomplete({ sessionToken, onChange }: PlacesAutocompleteProps) {
  const [asYouType, setAsYouType] = useState('');
  const [option, setOption] = useState<null | OptionType>(null);

  return (
    <ReactPlacesAutocomplete
      value={asYouType}
      onChange={setAsYouType}
      onError={(err) => {
        if (err === 'ZERO_RESULTS') return;

        console.error('Error Google Places Autocomplete', err);
        message.error('Address service error.');
      }}
      searchOptions={{
        types: ['address'],
        componentRestrictions: { country: ['us'] },
        sessionToken,
      }}
    >
      {({ getInputProps, suggestions, loading }) => {
        const { value: inputValue, onChange: onInputChange } = getInputProps<PlacesSelectProps>();
        return (
          <PlacesSelect
            placeholder="Search Places ..."
            autoFocus={true}
            isLoading={loading}
            styles={selectStyles}
            suggestions={suggestions}
            inputValue={inputValue}
            value={option}
            noOptionsMessage={() => 'Start typing to search addresses'}
            onInputChange={(value: string) => onInputChange({ target: { value } })}
            onChange={(option) => {
              if (isMultiValue(option)) {
                console.error('Unexpected - address option as array.');
                return;
              } else if (isSingleValue(option)) {
                onChange(option.value.placeId);
                setOption(option);
              } else {
                onChange(null);
                setOption(null);
              }
            }}
          />
        );
      }}
    </ReactPlacesAutocomplete>
  );
}
